export const newsOnPage = 3
export const eventsOnPage = 4
